import type { ComponentProps } from 'react';
import { clsx } from 'clsx';
import styles from './Select.module.scss';

export type SelectProps = ComponentProps<'select'> & {
  readonly label: string;
  readonly options: ReadonlyArray<{ value: string; label: string }>;
  readonly variant?: 'small' | 'medium';
};

const Select = ({ label, id, options, variant = 'medium', className, ...props }: SelectProps) => {
  return (
    <div className={className}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={clsx(styles.select, { [styles.small]: variant === 'small', [styles.medium]: variant === 'medium' })}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
